export const ENTRYANDCORE_FILE = 'ENTRYANDCORE_FILE';
// 更新
export const ENTRYANDCORE_UPDATE = 'ENTRYANDCORE_UPDATE';
